export const check_status = [
    { color: 'red', value: 'Sin Verificar' },
    { color: 'orange', value: 'Parcialmente Verificado' },
    { color: 'green', value: 'Verificado' }
];